export default new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
